module.exports = __webpack_public_path__ + "img/mozart.9d72cfe9.png";